// import React from "react";
// import { Link } from "react-router-dom";
// import "./Navbarr.css";

// const Navbarr = () => {
//   return (
//     <div>
//       <div className="nav">
//         <input type="checkbox" id="nav-check" />
//         <div className="nav-header">
//           <div className="nav-title">Mahesh PhohtoGraphy</div>
//         </div>
//         <div className="nav-btn">
//           <label htmlFor="nav-check">
//             <span></span>
//             <span></span>
//             <span></span>
//           </label>
//         </div>

//         <div>
//           <div className="nav-links">
//             <Link to="/">Home</Link>
//             <Link to="/about"></Link>
//             <Link to="/services">Services</Link>
//             <Link to="/blogs">Blogs</Link>
//             <Link to="/about">About</Link>
//             <Link to="login">Login</Link>
//           </div>
//           <div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Navbarr;

import React from "react";
import { signOut } from "firebase/auth";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { getAuth } from "firebase/auth";
import "./Navbarr.css";
const auth = getAuth();
const Navbarr = () => {
  const [user] = useAuthState(auth);
  const handleSignOut = () => {
    signOut(auth);
  };
  return (
    <div>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <Link className="link" to="/">
            Mahesh's Photography
          </Link>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Link className="link" to="/">
                Home
              </Link>

              <Link className="link" to="/about">
                About
              </Link>
              <Link className="link" to="/services">
                Services
              </Link>
              <Link className="link" to="/blogs">
                Blogs
              </Link>
            </Nav>
            <Nav>
              {/* <Link className="link" to="/login">
                Login
              </Link> */}
              {user ? (
                <button
                  className="btn btn-link text-white text-decoration-none"
                  onClick={handleSignOut}
                >
                  Sign out
                </button>
              ) : (
                <Link
                  className="btn btn-link text-white text-decoration-none"
                  to="/login"
                >
                  Login
                </Link>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Navbarr;
